import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Mall } from 'supporter';
import $ from 'jquery';

@Component
export default class GridsColums extends Vue {
  @State('malls', { namespace: 'mall' })
  private malls!: Mall[];
  protected getMallName(e: any): string {
    const name = this.malls.filter((item: any): any => {
      return item.mallNo === e
    })
    if (name.length > 0) {
      return name[0].mallName
    } else {
      return '_'
    }
  }
  protected getKorCurrency(value: any): any {
    if (value == null || isNaN(value)) {
      return 0;
    }
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  /** 화폐단위 추가 */
  protected addCurrencyCode({ value, currencyCode = 'KRW' }: { value: any, currencyCode: string}) {

    if (value == null || isNaN(value) || Number(value) === 0) {
      return `0 ${currencyCode === 'KRW' ? '원' : currencyCode}`;
    }

    return `${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} ${currencyCode === 'KRW' ? '원' : currencyCode}`;
  }

  public GridsColums: any = {

    '일자': {
      'header': '일자',
      'name': 'ymd',
      'align': 'center',
      'minWidth': 80
    },
    '판매건수': {
      'header': '판매건수',
      'name': 'totalOrderCnt',
      'align': 'center',
      'minWidth': 80,
      'formatter': (data: any): any => this.getKorCurrency(data.value),
      'copyOptions': { useFormattedValue: true }
    },
    '판매수량': {
      'header': '판매수량',
      'name': 'totalSaleCnt',
      'align': 'center',
      'minWidth': 80,
      'formatter': (data: any): any => this.getKorCurrency(data.value),
      'copyOptions': { useFormattedValue: true }
    },
    '판매금액': {
      'header': '판매금액(A)',
      'name': 'totalSaleAmt',
      'align': 'right',
      'minWidth': 110,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '프로모션할인금액': {
      'header': '프로모션 할인금액(B)',
      'name': 'totalPromotionDiscountAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '프로모션할인금액(상품)': {
      'header': '프로모션 상품할인금액(B)',
      'name': 'totalProductPromotionDiscountAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '적립금사용금액': {
      'header': '적립금사용금액(C)',
      'name': 'totalAccumulationAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '배송비': {
      'header': '배송비(D)',
      'name': 'totalDeliveryAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '외부결제': {
      'header': '외부결제(E)',
      'name': 'totalExternalPayAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '총결제금액': {
      'header': '총 결제금액(F) (F=A-B-C+D-E)',
      'name': 'totalPayAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '총상품판매금액': {
      'header': '총 상품판매금액(C) (C=A-B)',
      'name': 'totalProductSaleAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '프로모션할인금액구분': {
      'header': '프로모션 할인금액 구분(B)',
      'name': 'promotionType',
      'align': 'center',
      'minWidth': 120
    },
    '할인금액합계': {
      'header': '할인금액 합계',
      'name': 'totalPromotionAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '쇼핑몰부담': {
      'header': '쇼핑몰 부담',
      'name': 'mergeMall',
      'minWidth': 120,
      'childNames': ['totalMallDiscountAmt', 'mallDiscountRate']
    },
    '쇼핑몰할인금액': {
      'header': '할인금액',
      'name': 'totalMallDiscountAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '쇼핑몰비율': {
      'header': '비율(%)',
      'name': 'mallDiscountRate',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any): any => {
        if(data.value) {
          const retData = Number(data.value).toFixed(1);
          if(retData === '0.0'){
            return 0
          } else if (retData.lastIndexOf('.0') > 0) {
            return retData.replace('.0', '')
          } else {
            return retData
          }
        } else {
          return 0
        }
      },
      'copyOptions': { useFormattedValue: true }
    },
    '파트너부담': {
      'header': '파트너 부담',
      'name': 'mergePartner',
      'minWidth': 120,
      'childNames': ['totalPartnerDiscountAmt', 'partnerDiscountRate']
    },
    '파트너할인금액': {
      'header': '할인금액',
      'name': 'totalPartnerDiscountAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      'copyOptions': { useFormattedValue: true }
    },
    '파트너비율': {
      'header': '비율(%)',
      'name': 'partnerDiscountRate',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any): any => {
        if(data.value) {
          const retData = Number(data.value).toFixed(1);
          if(retData === '0.0'){
            return 0
          } else if (retData.lastIndexOf('.0') > 0) {
            return retData.replace('.0', '')
          } else {
            return retData
          }
        } else {
          return 0
        }
      },
      'copyOptions': { useFormattedValue: true }
    },
    '상품번호': {
      'header': '상품번호',
      'align': 'center',
      'minWidth': 80,
      'name': 'mallProductNo'
    },
    '상품관리코드': {
      'header': '상품관리코드',
      'align': 'center',
      'minWidth': 80,
      'name': 'productManagementCd'
    },
    '상품명': {
      'header': '상품명',
      'align': 'left',
      'minWidth': 180,
      'name': 'productName'
    },
    '옵션번호': {
      'header': '옵션번호',
      'align': 'center',
      'minWidth': 80,
      'name': 'mallOptionNo'
    },
    '옵션명': {
      'header': '옵션명: 옵션값',
      'align': 'left',
      'minWidth': 150,
      'name': 'displayOptionName',
      'formatter': (data: any): any => {
        const mallAdditionalProductNo = data.row.mallAdditionalProductNo;
        if (parseInt(mallAdditionalProductNo) > 0) {
          return `<span class="tag orange">추가</span> ${data.value}`;
        }

        return data.value;
      }
    },
    '쇼핑몰명': {
      'header': '쇼핑몰',
      'align': 'center',
      'minWidth': 180,
      'name': 'mallName',
      'formatter': (data: any): any => {
        return this.getMallName(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '파트너명': {
      'header': '파트너',
      'align': 'center',
      'minWidth': 180,
      'name': 'partnerName'
    },
    '브랜드명': {
      'header': '브랜드',
      'align': 'center',
      'minWidth': 180,
      'name': 'brandName'
    },
    '전시브랜드명': {
      'header': '전시브랜드',
      'align': 'center',
      'minWidth': 180,
      'name': 'displayBrandName'
    },
    '판매방식': {
      'header': '판매방식',
      'align': 'center',
      'minWidth': 80,
      'name': 'saleMethodTypeLabel'
    },
    '수수료율': {
      'header': '수수료율',
      'align': 'center',
      'minWidth': 80,
      'name': 'commissionRate',
      'formatter': (data: any): any => {
        if (data.value === null) {
          return '-';
        }

        return `${data.value}%`;
      },
      'copyOptions': { useFormattedValue: true }
    },
    '판매수수료': {
      'header': '판매수수료(AA)',
      'name': 'totalCommissionAmt',
      'align': 'right',
      'minWidth': 120,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '프로모션(쇼핑몰)': {
      'header': '프로모션 상품할인금액(쇼핑몰)(B1)',
      'name': 'totalMallPromotionAmt',
      'align': 'right',
      'minWidth': 180,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '프로모션(파트너)': {
      'header': '프로모션 상품할인금액(파트너)(B2)',
      'name': 'totalPartnerPromotionAmt',
      'align': 'right',
      'minWidth': 180,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '총상품판매금액(상품)': {
      'header': '총 상품판매금액(C)(C=A-B1-B2)',
      'name': 'totalPayAmt',
      'align': 'right',
      'minWidth': 180,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '쇼핑몰수익': {
      'header': '쇼핑몰수익(BB)(BB=AA-B1)',
      'name': 'totalMallProfitAmt',
      'align': 'right',
      'minWidth': 180,
      'formatter': (data: any): any => {
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '표준카테고리': {
      'header': '표준카테고리',
      'align': 'center',
      'minWidth': 180,
      'name': 'fullCategoryName'
    },
    '표준카테고리(캐시)': {
      'header': '표준카테고리',
      'align': 'left',
      'minWidth': 180,
      'name': 'categoryName',
      'formatter': (data: any): any => {
        if (data.value === null) {
          return '-';
        }
        const categoryDepth = Number($('#categoryDepth').val()) || 0;
        let categoryName = data.value;
        if (categoryDepth === 0) {
          return categoryName;
        }
        for (let index = categoryDepth; index >= 1; index--) {
          const depthCategoryName = $(`#depth${index}CategoryNo option:selected`).text();
          categoryName = `${depthCategoryName}>${categoryName}`;
        }
        return categoryName;
      },
      'copyOptions': { useFormattedValue: true }
    },
    '전시카테고리': {
      'header': '전시카테고리',
      'align': 'left',
      'minWidth': 180,
      'name': 'fullDisplayCategoryName'
    },
    '공급가입력': {
      'header': '공급가<br/>입력',
      'align': 'center',
      'minWidth': 80,
      'name': 'purchaseYn'
    },
    '공급가액': {
      'header': '공급가액',
      'align': 'right',
      'minWidth': 80,
      'name': 'totalPurchasePrice',
      'formatter': (data: any): any => {
        if (data.value === null) {
          return '-';
        }
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '매입가': {
      'header': '매입가액',
      'align': 'right',
      'minWidth': 80,
      'name': 'totalSupplyPrice',
      'formatter': (data: any): any => {
        if (data.value === null) {
          return '-';
        }
        return this.getKorCurrency(data.value);
      },
      'copyOptions': { useFormattedValue: true }
    },
    '판매상품수': {
      'header': '판매상품수',
      'name': 'totalProductCnt',
      'align': 'center',
      'minWidth': 80,
      'formatter': (data: any): any => this.getKorCurrency(data.value),
      'copyOptions': { useFormattedValue: true }
    }
  }
}